import hasAuthAccess from '@anm/auth/helpers/hasAuthAccess';
import { PricingSectionDiscount } from '@anm/components/pricing/PricingSection';
import template from 'lodash/fp/template';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import usePricingSale from '../../../../hooks/pricing/usePricingSale';
import { pricingSelectors } from '../../../../store/modules/pricing';
import { userSelectors } from '../../../../store/modules/user';

const useDiscount = () => {
  const sale = usePricingSale();
  const pricingContent = useSelector(pricingSelectors.selectPricingContent);
  const isUserFree = !!useSelector(userSelectors.selectWaveFreeUser);
  const [discount, setDiscount] = useState<PricingSectionDiscount | undefined>();
  const isUserPaid = hasAuthAccess() && !isUserFree;

  useEffect(() => {
    if (isUserPaid || !sale || !pricingContent?.discount) {
      return;
    }

    setDiscount({
      ...sale,
      text: template(pricingContent.discount)({ discount: sale.discount * 100 })
    });
  }, [isUserPaid, isUserFree, !!sale, !!pricingContent?.discount]);

  return discount;
};

export default useDiscount;
